//import axiosLoadingIndicatorFactory from '../axios-loading-indicator';
import axios from 'axios';
import handlers from './default-handlers';

export default {
    removeMember(vue, userIdentifier, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.team.removeMember, { user: userIdentifier }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    invite(vue, userIdentifiers, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.team.invite, { users: userIdentifiers }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    cancelInvite(vue, inviteIdentifier, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.team.cancelInvite, { identifier: inviteIdentifier }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    create(vue, teamName, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.team.create, { name: teamName }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    inviteLinks(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.user.team.inviteLinks).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    generateInviteLink(vue, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.user.team.inviteLink, {}).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
}
